import GameCard from "./GameCard";

class SecurityGameCard extends GameCard{
    constructor(isLucky, pathIDs, levelSecurityCardEffects) {
        super(isLucky);
        this.pathIDs = pathIDs;
        this.levelSecurityCardEffects = levelSecurityCardEffects;
    }
}
class SecurityGameCardEffect{
    constructor(expenses, brigadeChips, powerChips) {
        this.expenses = expenses;
        this.brigadeChips = brigadeChips;
        this.powerChips = powerChips;
    }
}
export {
    SecurityGameCard,
    SecurityGameCardEffect
};